import styled, { createGlobalStyle } from "styled-components";
import { breakpoint, color } from "./helpers/style/mixins";

export const GlobalStyle = createGlobalStyle`
   /* reduce Mui opacity */
  .MuiInputBase-root.Mui-disabled,
  .MuiFormLabel-root.Mui-disabled,
  .MuiOutlinedInput-root.Mui-disabled {
    color: ${({ theme }) =>
      theme.palette.type === "dark"
        ? "rgba(255, 255, 255, 0.3)"
        : "rgba(0, 0, 0, 0.2)"};
  }

  .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline {
    border-color: ${({ theme }) =>
      theme.palette.type === "dark"
        ? "rgba(255, 255, 255, 0.15)"
        : "rgba(0, 0, 0, 0.1)"};
  }

  .MuiFormHelperText-root.Mui-error {
    position: absolute;
    top: 100%;
  }

  .MuiTooltip-tooltip {
    font-size: 1rem;
    max-width: 100%;

    &.background-hidden{
      background-color: transparent !important;
      box-shadow: none !important;
      border: none !important;
      border-radius: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      max-width: none !important;
    }
  }

  /* A tooltip whose popper is kept mounted (PopperProps.keepMounted) leaves it
     in the page while closed, with only its content hidden: fixed in the
     top-left corner until it first opens, where an interactive one takes the
     clicks and the taps meant for the navbar icons, then at the end of <body>,
     where it lengthens the page. Hide the popper itself, out of the flow,
     until Popper.js positions it. */
  .MuiTooltip-popper:not([x-placement]) {
    position: fixed;
    top: 0;
    left: 0;
    visibility: hidden;
  }

  /* Article image tooltip styles - remove MUI default grey border */
  .MuiTooltip-tooltip.article-image-tooltip {
    background-color: transparent !important;
    box-shadow: none !important;
    border: none !important;
    padding: 0 !important;
    max-width: none !important;
  }

  .MuiTooltip-arrow.article-image-tooltip-arrow {
    color: white !important;
  }

  /* Ensure nested tooltips in article poppers have clean styling */
  .MuiTooltip-popper .article-image-tooltip {
    background-color: transparent !important;
    box-shadow: none !important;
    border: none !important;
  }

  /** react-phone-input-2 css overrides */
  .formik-phone-input {
    width: 100%;
  }

  .formik-phone-input .formik-phone-input__error-message {
    position: absolute;
    color: #f44336;
    margin: 3px 14px 0;
    font-size: 0.75rem;
    
  }

  div.react-tel-input .special-label {
    color: ${({ theme }) =>
      theme.palette.type === "dark"
        ? "rgba(255, 255, 255, 0.7)"
        : "rgba(0, 0, 0, 0.54)"};
    background: ${({ theme }) =>
      theme.palette.type === "dark" ? "#1e1e1e" : "#fff"};
    transition: color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms
  }

  div.react-tel-input .special-label {
    left: 11px;
  }

  div.react-tel-input:focus-within .special-label {
    color: ${color("primary")};
  }

  div.react-tel-input.error .special-label {
    color: #f44336;
  }


  div.react-tel-input .form-control {
    transition: none;
    ${({ theme }) =>
      theme.palette.type === "dark" &&
      `
      background-color: #1e1e1e;
      color: #fff;
      border-color: rgba(255, 255, 255, 0.23);
    `}
  }
  div.react-tel-input .form-control:focus:not(.invalid-number) {
    border: 2px solid ${color("primary")};
    box-shadow: none;
  }

  div.react-tel-input .flag-dropdown {
    ${({ theme }) =>
      theme.palette.type === "dark" &&
      `
      background-color: #2a2a2a;
      border-color: rgba(255, 255, 255, 0.23);
    `}
  }

  div.react-tel-input .flag-dropdown .selected-flag:hover,
  div.react-tel-input .flag-dropdown .selected-flag:focus,
  div.react-tel-input .flag-dropdown.open .selected-flag {
    ${({ theme }) => theme.palette.type === "dark" && `background-color: #333;`}
  }

  .gmap-marker-label {
    margin-top: 2.1rem;
    margin-left: 1.75rem;
  }

  /* ===== Comprehensive Dark Mode Overrides ===== */
  ${({ theme }) =>
    theme.palette.type === "dark" &&
    `
    /* Global body background */
    body {
      background-color: #121212;
      color: #e0e0e0;
    }

    /* MUI Paper / Card surfaces */
    .MuiPaper-root,
    .MuiCard-root,
    .MuiDialog-paper,
    .MuiPopover-paper,
    .MuiMenu-paper,
    .MuiAccordion-root {
      background-color: #1e1e1e !important;
      color: #e0e0e0;
    }

    /* MUI Tabs */
    .MuiTabs-root {
      background-color: #1e1e1e !important;
      border-color: #333 !important;
    }

    /* MUI Input fields */
    .MuiInputBase-root {
      background-color: #2a2a2a !important;
      color: #e0e0e0 !important;
    }

    .MuiOutlinedInput-notchedOutline {
      border-color: rgba(255, 255, 255, 0.23) !important;
    }

    .MuiSelect-icon {
      color: rgba(255, 255, 255, 0.7);
    }

    /* MUI Table body cells */
    .MuiTableCell-body {
      color: #e0e0e0;
      border-bottom-color: #333;
    }

    .MuiTableCell-head {
      border-bottom-color: #444;
    }

    /* Borders */
    .MuiDivider-root {
      background-color: #333;
    }

    /* MUI Chips */
    .MuiChip-root {
      background-color: #333 !important;
      color: #e0e0e0;
    }

    .MuiChip-outlined {
      border-color: #555 !important;
      background-color: transparent !important;
    }

    /* Buttons - outlined variant */
    .MuiButton-outlined {
      border-color: rgba(255, 255, 255, 0.3);
    }

    /* MUI Select / MenuItem */
    .MuiMenuItem-root {
      color: #e0e0e0;
    }

    .MuiListItem-root:hover {
      background-color: #333 !important;
    }

    /* Catch inline white backgrounds on common MUI Box-based components */
    [style*="background-color: white"],
    [style*="background-color: rgb(255, 255, 255)"],
    [style*="backgroundColor: white"],
    [style*="background: white"] {
      background-color: #1e1e1e !important;
    }

    [style*="background-color: #fff"],
    [style*="backgroundColor: #fff"] {
      background-color: #1e1e1e !important;
    }

    [style*="background-color: #ffffff"],
    [style*="backgroundColor: #ffffff"] {
      background-color: #1e1e1e !important;
    }

    [style*="background-color: #f5f5f5"],
    [style*="backgroundColor: #f5f5f5"],
    [style*="background-color: #fafafa"],
    [style*="backgroundColor: #fafafa"],
    [style*="background-color: #f8f9fa"],
    [style*="backgroundColor: #f8f9fa"],
    [style*="background-color: #f9f9f9"],
    [style*="backgroundColor: #f9f9f9"] {
      background-color: #2a2a2a !important;
    }

    /* Roadmaps / Billing table inputs */
    .orders tr:nth-child(2n + 1) td {
      background-color: #252525 !important;
    }

    /* Autocomplete dropdowns */
    .MuiAutocomplete-paper {
      background-color: #1e1e1e !important;
    }

    .MuiAutocomplete-option:hover {
      background-color: #333 !important;
    }

    /* Calendar / Pickers */
    .MuiPickersBasePicker-container {
      background-color: #1e1e1e;
    }

    .MuiPickersCalendarHeader-switchHeader {
      color: #e0e0e0;
    }

    /* Scrollbar */
    ::-webkit-scrollbar-track {
      background: #1e1e1e;
    }

    ::-webkit-scrollbar-thumb {
      background: #555;
      border-radius: 4px;
    }

    ::-webkit-scrollbar-thumb:hover {
      background: #777;
    }
  `}
`;

export const ContentWrapper = styled.div`
  padding-top: 90px;
  @media screen and (min-width: ${breakpoint("lg")}) {
    padding-top: 145px;
  }
`;
